import React, { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { CustomAccordion } from "../components";
import { TotalChart, ScopeChart, RenewableNonRenewableChart, UtilityTypeChart, BusinessUnitChart, SiteTypeChart, RegionChart, CountryChart, SiteChart, EstimatesChart } from "../../charts";
import { DropdownProps } from "../types";

const DateRangeDropdown = ({ searchFilters, subTypeChart, currentMainTab }: DropdownProps) => {
  const currentDate = dayjs.utc();
  const [dateRangeStartDate, setDateRangeStartDate] = useState<Dayjs>(dayjs(currentDate.date(1)).subtract(2, "month"));
  const [dateRangeEndDate, setDateRangeEndDate] = useState<Dayjs>(dayjs(currentDate));
  const [dateRangeType, setDateRangeType] = useState<string>("MONTHLY");

  return <CustomAccordion
    titleAccordion="Date Range"
    dateRangeType={dateRangeType}
    setDateRangeType={setDateRangeType}
    startDate={dateRangeStartDate}
    endDate={dateRangeEndDate}
    setStartDate={setDateRangeStartDate}
    setEndDate={setDateRangeEndDate}
    panelNumber={2}
    allowPeriods
  >
    <TotalChart
      chartTitle="Total"
      subTabName={subTypeChart}
      dateRangeType={dateRangeType}
      currentMainTab={currentMainTab}
      startDate={dateRangeStartDate}
      endDate={dateRangeEndDate}
      searchFilters={searchFilters}
    />
    <ScopeChart
      chartTitle="Scope"
      subTabName={subTypeChart}
      dateRangeType={dateRangeType}
      currentMainTab={currentMainTab}
      startDate={dateRangeStartDate}
      endDate={dateRangeEndDate}
      searchFilters={searchFilters}
    />
    {(currentMainTab === "Consumption" || currentMainTab === "Financials")
      && <RenewableNonRenewableChart
        chartTitle="Renewable vs. Non-Renewable"
        subTabName={subTypeChart}
        dateRangeType={dateRangeType}
        currentMainTab={currentMainTab}
        startDate={dateRangeStartDate}
        endDate={dateRangeEndDate}
        searchFilters={searchFilters}
      />}
    <UtilityTypeChart
      chartTitle="Utility Type"
      subTabName={subTypeChart}
      dateRangeType={dateRangeType}
      currentMainTab={currentMainTab}
      startDate={dateRangeStartDate}
      endDate={dateRangeEndDate}
      searchFilters={searchFilters}
    />
    <BusinessUnitChart
      chartTitle="Business Unit"
      subTabName={subTypeChart}
      dateRangeType={dateRangeType}
      currentMainTab={currentMainTab}
      startDate={dateRangeStartDate}
      endDate={dateRangeEndDate}
      searchFilters={searchFilters}
    />
    <SiteTypeChart
      chartTitle="Site Type"
      subTabName={subTypeChart}
      dateRangeType={dateRangeType}
      currentMainTab={currentMainTab}
      startDate={dateRangeStartDate}
      endDate={dateRangeEndDate}
      searchFilters={searchFilters}
    />
    <RegionChart
      chartTitle="Region"
      subTabName={subTypeChart}
      dateRangeType={dateRangeType}
      currentMainTab={currentMainTab}
      startDate={dateRangeStartDate}
      endDate={dateRangeEndDate}
      searchFilters={searchFilters}
    />
    <CountryChart
      chartTitle="Country"
      subTabName={subTypeChart}
      dateRangeType={dateRangeType}
      currentMainTab={currentMainTab}
      startDate={dateRangeStartDate}
      endDate={dateRangeEndDate}
      searchFilters={searchFilters}
    />
    <SiteChart
      chartTitle="Site"
      subTabName={subTypeChart}
      dateRangeType={dateRangeType}
      currentMainTab={currentMainTab}
      startDate={dateRangeStartDate}
      endDate={dateRangeEndDate}
      searchFilters={searchFilters}
    />
    <EstimatesChart
      chartTitle="Estimates"
      subTabName={subTypeChart}
      dateRangeType={dateRangeType}
      currentMainTab={currentMainTab}
      startDate={dateRangeStartDate}
      endDate={dateRangeEndDate}
      searchFilters={searchFilters}
    />
  </CustomAccordion>
}

export default DateRangeDropdown;